import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import { useHistory, useParams } from 'react-router-dom'
import { Form as RBForm } from 'react-bootstrap'
import { Formik, Form } from 'formik'
import { string, object } from 'yup'
import {
  useErrorService,
  ABSpinner,
  Button,
  useNotificationService,
} from '@abroad/components'
import API from '../utils/API'
import { InputField } from '../components/form'

const NameFormInitialValues = {
  firstName: '',
  lastName: '',
}

export const UpdateName = () => {
  const { clientId } = useParams()
  const [isLoading, setIsLoading] = useState(true)
  const [initialValues, setInitialValues] = useState(NameFormInitialValues)
  const [user, setUser] = useState([])
  const [isSubmitting, setIsSubmitting] = useState(false)
  const Error = useErrorService()
  const Notification = useNotificationService()
  const history = useHistory()
  const nameRegex = /^[A-Za-z\s-]+$/
  const validationSchema = object().shape({
    firstName: string()
      .matches(nameRegex, 'Please enter a valid First Name')
      .max(35, 'First Name cannot be more than 35 characters')
      .required('Required'),
    lastName: string()
      .matches(nameRegex, 'Please enter a valid Last Name')
      .max(35, 'Last Name cannot be more than 35 characters')
      .required('Required'),
  })

  useEffect(() => {
    const getUserInfo = async () => {
      try {
        const { data } = await API.AdminAPI.coachClient.getClientSpecificData(
          clientId,
          {
            fields: ['fname', 'lname', 'fullName'],
          },
        )
        if (data) {
          setUser(data)
          setIsLoading(false)
          setInitialValues({
            firstName: data?.fname || '',
            lastName: data?.lname || '',
          })
        }
      } catch (e) {
        setIsLoading(false)
        Error.showError(e)
      }
    }
    getUserInfo()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const onSubmit = async (values) => {
    setIsSubmitting(true)
    try {
      const { data } = await API.AdminAPI.coachClient.updateName(clientId, {
        fname: values.firstName.trim(),
        lname: values.lastName.trim(),
      })
      if (data) {
        setIsSubmitting(false)
        Notification.showNotification('User name has been updated!', 'success')
        history.push({
          pathname: `/admin/users/${clientId}`,
          state: { profileNeedsRefresh: true },
        })
      }
    } catch (e) {
      setIsSubmitting(false)
      Error.showError(e)
    }
  }

  if (isLoading) {
    return <ABSpinner />
  }

  return (
    <>
      <Helmet>
        <title>{`${user?.fname || ''}'s Update Name | Abroad`}</title>
        <meta
          name='title'
          content={`${user?.fname || ''}'s Update Name | Abroad`}></meta>
        <meta
          property='og:title'
          content={`${user?.fname || ''}'s Update Name | Abroad`}></meta>
        <meta
          property='twitter:title'
          content={`${user?.fname || ''}'s Update Name | Abroad`}></meta>
        <link
          rel='canonical'
          href={`${process.env.REACT_APP_DOMAIN}/admin/users/${clientId}/update-name`}></link>
        <meta
          property='og:url'
          content={`${process.env.REACT_APP_DOMAIN}/admin/users/${clientId}/update-name`}></meta>
        <meta
          property='twitter:url'
          content={`${process.env.REACT_APP_DOMAIN}/admin/users/${clientId}/update-name`}></meta>
      </Helmet>
      <main>
        <section className='update-name update-email d-flex justify-content-center align-item-center'>
          <Formik
            displayName='update-name-form'
            validationSchema={validationSchema}
            initialValues={initialValues}
            enableReinitialize={true}
            onSubmit={onSubmit}>
            {({ handleSubmit, values, isValid }) => {
              const isFirstNameEmpty = !values?.firstName?.trim()
              const isLastNameEmpty = !values?.lastName?.trim()
              const isSaveDisabled =
                isLoading ||
                isSubmitting ||
                isFirstNameEmpty ||
                isLastNameEmpty ||
                !isValid

              return (
                <RBForm
                  onSubmit={handleSubmit}
                  as={Form}
                  className='profile update-name-form px-4 px-lg-0'>
                  <div className='update-name-fields'>
                    <InputField
                      name='firstName'
                      type='text'
                      placeholder='Enter First Name.'
                      className='update-name-input'
                      // hasErrorMessagePadding={false}
                      formGroupProps={{ className: 'update-name-group' }}
                      label='FIRST NAME'
                      labelProps={{ className: 'update-name-label' }}
                      displayFlex={false}
                      showErrorMessage={false}
                      disabled={isSubmitting}
                    />
                    <InputField
                      name='lastName'
                      type='text'
                      placeholder='Enter Last Name.'
                      className='update-name-input'
                      // hasErrorMessagePadding={false}
                      formGroupProps={{ className: 'update-name-group' }}
                      label='LAST NAME'
                      labelProps={{ className: 'update-name-label' }}
                      displayFlex={false}
                      showErrorMessage={false}
                      disabled={isSubmitting}
                    />
                  </div>
                  <div className='update-name-actions text-right'>
                    <Button
                      variant='gray'
                      disabled={isSaveDisabled}
                      isLoading={isLoading || isSubmitting}
                      size='md'
                      className='text-uppercase line-height-normal border-radius-3'
                      type='submit'>
                      Save
                    </Button>
                  </div>
                </RBForm>
              )
            }}
          </Formik>
        </section>
      </main>
    </>
  )
}
